var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorporate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1302 24.5V22.1667C19.1302 20.929 18.6385 19.742 17.7634 18.8668C16.8882 17.9917 15.7012 17.5 14.4635 17.5H7.46354C6.22586 17.5 5.03888 17.9917 4.16371 18.8668C3.28854 19.742 2.79688 20.929 2.79688 22.1667V24.5",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1328 3.64844C20.1335 3.90787 21.0198 4.49225 21.6524 5.30984C22.2851 6.12744 22.6284 7.13197 22.6284 8.16577C22.6284 9.19957 22.2851 10.2041 21.6524 11.0217C21.0198 11.8393 20.1335 12.4237 19.1328 12.6831",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1328 24.5007V22.1673C26.132 21.1334 25.7879 20.1289 25.1544 19.3117C24.5209 18.4945 23.634 17.9108 22.6328 17.6523",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9635 12.8333C13.5409 12.8333 15.6302 10.744 15.6302 8.16667C15.6302 5.58934 13.5409 3.5 10.9635 3.5C8.38621 3.5 6.29688 5.58934 6.29688 8.16667C6.29688 10.744 8.38621 12.8333 10.9635 12.8333Z",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporate);
export default __webpack_public_path__ + "static/media/Corporate.5ac93ca4c908f085c5da83d64949f538.svg";
export { ForwardRef as ReactComponent };